import React, { useMemo, useState, useEffect } from 'react';
import ReactGA from 'react-ga';
import * as localForage from 'localforage';
const favorite = require('../assets/favorite.svg');
const favorited = require('../assets/favorited.svg');

export function FavoriteButton(props: { entryId: number }) {
  const key = 'favorites';
  const [favorites, setFavorites] = useState<number[]>([]);
  const [loading, setLoading] = useState(true);
  const isFavorited = favorites.includes(props.entryId);

  // Initial Data Fetching...
  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      const result: number[] = await localForage.getItem(key);
      result && setFavorites(result);
      setLoading(false);
    };
    fetch();
  }, [props.entryId]);

  // Click Handler...
  const handler = () => {
    const newFavorites = isFavorited ? favorites.filter(n => n !== props.entryId) : [...favorites, props.entryId];
    localForage.setItem(key, newFavorites);
    ReactGA.event({
      category: 'Favorite',
      action: isFavorited ? 'Remove' : 'Add',
      label: `${props.entryId}`,
    });
    setFavorites(newFavorites);
  };

  if (loading) {
    return null;
  }

  return (
    <div className="buttons" style={{ position: 'absolute', bottom: 10, right: 10 }}>
      <a className="button" style={{background: "transparent", border: "none"}} onClick={handler}>
        <span className="icon">
          <img src={isFavorited ? favorited : favorite} />
        </span>
      </a>
    </div>
  );
}
